import React from 'react';

import { getBankLogo } from '../../utils/getBankLogo';
import { getBalanceDisplay } from '../../utils/usCurrencyFormatter';

const PaymentDetailOption = ({ item, totalInvestment }) => {

    const isWallet = item?.sourceType === 'Wallet';
    const isInsufficientBalance = isWallet && totalInvestment > item?.balance;

    return (
        <>
            {getBankLogo(item?.brandName)} {item?.brandName === 'DWOLLA' ? 'Dwolla Wallet' : item?.brandName || ''}{' '}
            {item?.sourceType !== 'Wallet' && item?.sourceType !== 'add new' && `*** ${item.lastFourDigit || ''}`}
            {isWallet && !isInsufficientBalance ? '$' : ''}
            <span>
                {isInsufficientBalance ? (
                    <span className='error-text'>Insufficient balance</span>
                ) : (
                    getBalanceDisplay(item.balance)
                )}
            </span>
        </>
    )
};

export default PaymentDetailOption